/* BASAL GT — paquetes, carrito nativo, CTA fijo y clics de WhatsApp. Sin librerías externas. */
(function () {
  'use strict';
  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data || {});
    } catch (e) {}
  }
  /* Clic en WhatsApp: evento propio. Vista, carrito, checkout y compra ya los registra Shopify. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href*="wa.me/"]') : null;
    if (!a) return;
    track('whatsapp_click', { product: a.getAttribute('data-bgt-wa') || '', location: a.getAttribute('data-bgt-wa-loc') || window.location.pathname });
  });

  Array.prototype.forEach.call(document.querySelectorAll('[data-bgt-form]'), function (form) {
    /* getAttribute: el formulario tiene un campo llamado "id", así que form.id no sirve */
    var formId = form.getAttribute('id');
    var status = form.querySelector('[data-bgt-status]');
    var submits = form.querySelectorAll('button[type="submit"]');
    var priceNodes = document.querySelectorAll('[data-bgt-price="' + formId + '"]');
    var labelNodes = document.querySelectorAll('[data-bgt-pack-label="' + formId + '"]');
    var busy = false;
    function setText(nodes, t) { Array.prototype.forEach.call(nodes, function (n) { n.textContent = t; }); }
    function say(msg, isError) { if (!status) return; status.textContent = msg; status.classList.toggle('is-error', !!isError); }
    function sync() {
      var r = form.querySelector('.bgt-pack__input:checked');
      if (!r) return;
      setText(priceNodes, r.getAttribute('data-price') || '');
      setText(labelNodes, r.getAttribute('data-label') || '');
    }
    function setBusy(on) {
      busy = on;
      Array.prototype.forEach.call(submits, function (b) {
        if (b.hasAttribute('data-bgt-soldout')) return;
        b.disabled = on;
        b.classList.toggle('is-loading', on);
        b.setAttribute('aria-busy', on ? 'true' : 'false');
      });
    }
    form.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('bgt-pack__input')) { say(''); sync(); }
    });
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return; /* respaldo: envío nativo */
      e.preventDefault();
      if (busy) return;
      setBusy(true);
      say('Agregando tu pedido…');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
        .then(function (res) {
          if (!res.ok) throw new Error(res.status === 422 ? 'No hay suficiente disponibilidad para este paquete. Probá con otro o escribinos por WhatsApp.' : 'No pudimos agregar tu pedido. Intentá de nuevo o escribinos por WhatsApp.');
          say('¡Listo! Te llevamos a completar tu pedido…');
          window.location.href = form.getAttribute('data-next') || '/checkout';
        })
        .catch(function (err) {
          setBusy(false);
          say(err && err.message ? err.message : 'No pudimos agregar tu pedido. Intentá de nuevo.', true);
        });
    });
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) { setBusy(false); say(''); } });
    sync();
  });

  /* CTA fijo en móvil: aparece al pasar el botón del hero y se oculta mientras el selector está a la vista. */
  var sticky = document.querySelector('[data-bgt-sticky]');
  var after = document.querySelector('[data-bgt-sticky-after]');
  var hide = document.querySelector('[data-bgt-sticky-hide]');
  if (sticky && after && 'IntersectionObserver' in window) {
    var btn = sticky.querySelector('button');
    var pastHero = false, buyVisible = false;
    var render = function () {
      var on = pastHero && !buyVisible;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      if ('inert' in sticky) sticky.inert = !on;
      if (btn) btn.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('bgt-sticky-on', on);
    };
    new IntersectionObserver(function (en) { en.forEach(function (x) { pastHero = !x.isIntersecting && x.boundingClientRect.top < 0; }); render(); }).observe(after);
    if (hide) new IntersectionObserver(function (en) { en.forEach(function (x) { buyVisible = x.isIntersecting; }); render(); }, { threshold: 0.15 }).observe(hide);
    render();
  }
})();